import type { QueryClient } from "@tanstack/react-query";

import {
	createRootRouteWithContext,
	Outlet,
	ScrollRestoration,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/router-devtools";

// Hooks
import { useMediaQuery } from "@uidotdev/usehooks";

// UI Provider
import { Toaster } from "@/components/ui/toaster";

// UI
import NotSupportMobile from "@/components/NotSupportMobile";

// import * as Sentry from "@sentry/react";

// Sentry.init({
// 	dsn: "https://b89836d9806d8a92814b7f94bc9b1dbc@o4507859318079488.ingest.de.sentry.io/4507915716264016",
// 	integrations: [
// 		Sentry.browserTracingIntegration(),
// 		Sentry.replayIntegration(),
// 	],
// 	// Tracing
// 	tracesSampleRate: 1.0, //  Capture 100% of the transactions
// 	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
// 	tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
// 	// Session Replay
// 	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
// 	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

export const Route = createRootRouteWithContext<{
	queryClient: QueryClient;
}>()({
	component: Root,
});

function Root() {
	const isSmallDevice = useMediaQuery("only screen and (max-width : 768px)");
	return isSmallDevice ? (
		<NotSupportMobile />
	) : (
		<>
			<Outlet />
			<ScrollRestoration />
			{/* <TanStackRouterDevtools /> */}
			<Toaster />
		</>
	);
}
